












import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrPatientDetailNav extends Vue {
  @Prop()
  private cState: any;
  @Prop()
  private patient: any;
  private cWrap: any = "";
  /**
   * @description 跳转
   */
  private goTo(part) {
    this.$router.replace({
      path: "/main/idr/patient-detail",
      query: {
        patient_id: this.patient.patient_id,
        part
      }
    });
  }
  /**
   * @description 切换开关
   */
  private triggerWrap(name) {
    this.$emit("stateChange", "");
    this.cWrap = name;
  }
  /**
   * @description 开始填充
   */
  private fill() {
    this.$emit("fill");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (
      this.cState === "舌象数据" ||
      this.cState === "面象数据" ||
      this.cState === "脉象数据"
    ) {
      this.cWrap = "中医影像";
    }
  }
}
